/**
 * useMobileDetection Hook
 * Detect mobile/tablet screen size untuk responsive UI
 */

import { useState, useEffect } from 'react'

export function useMobileDetection() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const isMobileSize =
        window.innerWidth <= 768 ||
        (window.innerWidth <= 1024 && window.innerHeight > window.innerWidth) // Portrait tablet
      setIsMobile(isMobileSize)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return { isMobile }
}

